interface RecurrentPayProp {
	disabled?: boolean;
}

export const RecurrentPayIcon = ({ disabled }: RecurrentPayProp) => (
	<svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M10.5694 7.725C9.23161 7.45316 7.79389 7.64962 6.51975 8.38524C3.74509 9.9872 2.79688 13.5394 4.40187 16.3193C6.00685 19.0992 9.55726 20.0542 12.3319 18.4522C12.9743 18.0814 13.5187 17.606 13.9562 17.0599M10.5694 7.725L8.28908 11.657M10.5694 7.725L6.50425 4.93984"
			stroke={disabled ? '#636172' : '#0F0F0F'}
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M16.2333 10.0775L18.8719 7.43855M17.1128 6.11906L17.3164 5.88331C17.7289 5.47089 18.2882 5.23922 18.8714 5.23926C19.4547 5.2393 20.014 5.47105 20.4263 5.88353C20.8387 6.296 21.0704 6.85542 21.0703 7.43871C21.0703 8.022 20.8385 8.58138 20.4261 8.9938L20.1913 9.19788M17.9924 11.397L17.8178 11.6319C17.4004 12.0443 16.8374 12.2756 16.2506 12.2756C15.6639 12.2756 15.1008 12.0443 14.6835 11.6319C14.4777 11.4286 14.3143 11.1865 14.2028 10.9195C14.0913 10.6526 14.0339 10.3662 14.0339 10.0769C14.0339 9.7876 14.0913 9.50118 14.2028 9.23425C14.3143 8.96732 14.4777 8.72518 14.6835 8.52186L14.9139 8.31822"
			stroke={disabled ? '#636172' : '#0F0F0F'}
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
